import { ICategoryModel } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const categoryAdapter: EntityAdapter<ICategoryModel> = createEntityAdapter<ICategoryModel>({
	selectId: category => category.categoryId
});